import { JobConfiguration } from '../../job-configuration';
import { JobType } from '../../../../api/jobs.dao';
import { JobDtoType } from '../../index';

export class EventBlueprintTriggerJob extends JobConfiguration {
    public readonly type = JobType.EventBlueprintTrigger;
    public readonly name = 'Event Blueprint Trigger';
    public readonly description = '';
    /**
     * implementation of this config do not have api call so there is no need execute method
     */
    public execute(): Promise<JobDtoType> {
        throw new Error(`${JobType.EventBlueprintTrigger} Job execution is not supported.`);
    }
}

export default {
    [JobType.EventBlueprintTrigger]: EventBlueprintTriggerJob
};